import { OrderChannelModel } from '@app/interfaces/order/channel';
import { axiosApi } from './axios.api';

export const getOrderChannels = async (): Promise<any | undefined> => {
  try {
    const channelsApi = `/api/order/channels`;
    const response = await axiosApi.get<OrderChannelModel[]>(channelsApi);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};